import DVCApi from './_dvcApi';
import httpClient, {FormMultiPart} from '@/apis/base/httpclient';
class DVCFileAPI extends DVCApi {
  constructor() {
    super();
  }
  controllerName = 'DVCFiles';

  /**
   * Hàm lưu dữ liệu
   * @param {} param
   * @returns
   */
  saveVoucherDvc(param) {
    let request = {
      url: this.getAPIUrl() + '/saveDvc',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm lưu tệp đính kèm
   * @param {} param
   * @returns
   */
  getDoucumentDvc(param) {
    let request = {
      url: this.getAPIUrl() + '/document',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm lấy dữ liệu sửa
   * @param {} id
   * @returns
   */
  async getDataVoucherDvc(id) {
    let request = {
      url: this.getAPIUrl() + '/getEditDvc',
      data: {id},
    };

    return await httpClient.getAsync(request);
  }
  /**
   * Hàm lấy dữ liệu dvc từ filecode
   * @param {} fileCode
   * @returns
   */
  async GetDvcFileByFileCode(fileCode) {
    let request = {
      url: this.getAPIUrl() + '/getDvcFileByFileCode',
      data: {fileCode},
    };

    return await httpClient.getAsync(request);
  }
  /**
   * Hàm lấy dữ liệu thêm mới
   * @param {} id
   * @returns
   */
  async getNewVoucherDvc() {
    let request = {
      url: this.getAPIUrl() + '/getNew',
      data: {},
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Thực hiện lấy dữ liệu chứng từ và loại mẫu chứng từ giao dịch theo nghiệp vụ
   * nthien4 06.10.2022
   */
  async getVoucherByBusiness(voucherType, isGetVoucherWithdraw, fromDate, sentDate) {
    let request = {
      url: this.getAPIUrl() + '/getVoucherByBusiness',
      data: {voucherType, isGetVoucherWithdraw, fromDate, sentDate},
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Thực hiện lấy dữ liệu chứng từ và loại mẫu chứng từ giao dịch theo nghiệp vụ (cho chức năng kết xuất xml)
   */
  async getVoucherByBusinessForExportXML(voucherType, isGetVoucherWithdraw, fromDate, sentDate) {
    let request = {
      url: this.getAPIUrl() + '/getVoucherByBusinessForExportXML',
      data: {voucherType, isGetVoucherWithdraw, fromDate, sentDate},
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Hàm lấy dữ liệu báo cáo khi thêm mẫu báo cáo
   * @param {} param
   * @returns
   * nthien4 15.10.2022
   */
  submitDataDvc(param) {
    let request = {
      url: this.getAPIUrl() + '/getDataSubmit',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  updateIsViewField(param) {
    let request = {url: this.getAPIUrl() + '/update-is-view', data: param};

    return httpClient.postAsync(request);
  }

  groupDataDvcFile(data) {
    let request = {url: this.getAPIUrl() + '/group-data-dvc-file', data};

    return httpClient.postAsync(request);
  }

  /**
   * Kiểm tra trạng thái nhiều hồ sơ thanh toán
   */
  async getAllDoucumentStatus(reportYear, lastModifiedDate, dvcToken) {
    let request = {
      url: `${this.getAPIUrl()}/allDocumentStatus?reportYear=${reportYear}&lastModifiedDate=${lastModifiedDate}`,
      data: {dvcToken},
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Kiểm tra trạng thái nhiều hồ sơ thanh toán
   */
  async getDoucumentStatus(param) {
    let request = {
      url: this.getAPIUrl() + '/documentStatus',
      data: param,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Thực hiện ký duyệt hồ sơ giao dịch KBNN
   * dtnga3 (17.10.2022)
   */
  signDVCESign(param) {
    let request = {
      url: this.getAPIUrl() + '/approve',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm từ chối duyệt hồ sơ
   * DMNGOC 20/10/2022
   */
  RejectDocument(param) {
    let request = {
      url: this.getAPIUrl() + '/RejectDvc',
      data: param,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Hàm gửi duyệt hồ sơ
   * DMNGOC 20/10/2022
   */
  async SendApprovalDocument(param) {
    let request = {
      url: this.getAPIUrl() + '/SendApprovalDvc',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm kiểm tra trạng thái hồ sơ từ KBNN (form chi tiết)
   * @param {} param
   * @returns
   * nthien4 22.10.2022
   */
  updateKBNNStatus(param, dvcToken, typeUpdate) {
    let request = {
      url: this.getAPIUrl() + '/updateKBNNStatus',
      data: {param, dvcToken, typeUpdate},
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm duyệt bằng usbTokens
   * @param {*} param
   * @returns
   */
  approveByUsbToken(param) {
    let request = {
      url: this.getAPIUrl() + '/approveByUsbToken',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm duyệt lại
   * @param {*} param
   * @returns
   * nthien4 22/09/23
   */
  approveDVCAgain(param) {
    let request = {
      url: this.getAPIUrl() + '/approveDVCAgain',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /*
   * Lấy link chứng từ ghi nợ cần tải
   */
  async getLinkUrlKBNN(vPath) {
    let request = {
      url: this.getAPIUrl() + '/getLinkUrlKBNN',
      data: {vPath},
    };

    return await httpClient.getAsync(request);
  }
  getDetailDataC203(param) {
    let request = {
      url: this.getAPIUrl() + '/getDetailDataC203',
      data: param,
    };
    return httpClient.postAsync(request);
  }

  getDetailDataM04b(param) {
    let request = {
      url: this.getAPIUrl() + '/getDetailDataM04b',
      data: param,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Hàm xuất khẩu dữ liệu ở phần kết xuất
   * DMNGOC 17/11/2022
   */
  dvcExportSubmitData(param) {
    let request = {
      url: this.getAPIUrl() + '/DvcExportSubmitData',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm lấy số hồ sơ tự tăng
   * @returns
   */
  async getFileCodeDvc(subCode, dvcToken, sentDate) {
    let request = {
      url: this.getAPIUrl() + '/getFileCodeDvc',
      data: {subCode, dvcToken, sentDate},
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Hàm lấy mã hồ sơ mới nhất khi duyệt trùng mã
   * @param {*} param
   * @returns
   */
  updateNewDVCFileCode(param) {
    let request = {
      url: this.getAPIUrl() + '/updateNewDVCFileCode',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  getDataDVCQLTSMISAVoucher(param) {
    let request = {
      url: this.getAPIUrl() + '/getDataDVCQLTSMISAVoucher',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  getDetailC202NotGroup(param) {
    let request = {
      url: this.getAPIUrl() + '/getDetailC202NotGroup',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  getDetailC402NotGroup(param) {
    let request = {
      url: this.getAPIUrl() + '/getDetailC402NotGroup',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  getDetailM01(param) {
    let request = {
      url: this.getAPIUrl() + '/getDetailM01',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm lấy số hồ sơ tự tăng
   * @returns
   */
  async checkShowCompanyDVCNoti() {
    let request = {
      url: this.getAPIUrl() + '/checkShowCompanyDVCNoti/',
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Lấy danh sách số tiền
   */
  async searchAsync(param) {
    let request = {
      url: this.getAPIUrl() + '/searchAmount',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy danh sách số tiền
   */
  async distinctApprover(param) {
    let request = {
      url: this.getAPIUrl() + '/DistinctApprover',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Kiểm tra đơn vị đã đăng ký sử dụng KBĐT chưa
   * dtnga3 (31.07.2023)
   */
  async checkRegisterDVC(param) {
    let request = {
      url: this.getAPIUrl() + '/checkRegisterDVC',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu chứng từ chi tiết
   * Dùng riêng cho tiện ích mẫu 04.a/TT
   * lhphong 18.09.2023
   * @param {*} refType
   * @param {*} refId
   * @returns
   */
  async GetDataVoucherByRefType(refType, refId) {
    let request = {
      url: this.getAPIUrl() + '/GetDataVoucherByRefType',
      data: {refType, refId},
    };

    return httpClient.getAsync(request);
  }

  /**
   * Upload nhiều file
   * @param {*} files : File upload
   * @param {*} type : Loại file
   */
  uploadsHaveConvert(files, type) {
    let data = new FormData();
    files.forEach(file => {
      data.append('file', file, file.name);
    });
    if (type) {
      data.append('type', type);
    }

    let request = {
      url: [this.getAPIUrl(), 'UploadFilesHaveConvert'].join('/'),
      data: data,
    };

    return this.postAsync(request, false, true, FormMultiPart);
  }

  /**
   * Upload file có convert ảnh sang pdf
   * @param {*} file : File upload
   * @param {*} type : Loại file
   */
  uploadHasConvert(file, type) {
    let data = new FormData();
    data.append('file', file);
    if (type) {
      data.append('type', type);
    }

    let request = {
      url: this.getAPIUrl() + '/UploadFileHasConvert',
      data: data,
    };

    return this.postAsync(request, false, true, FormMultiPart);
  }

  /**
   * Lấy dữ liệu ms09
   * @param {*} payload
   * @returns
   * tbngoc 16.01.2023
   */
  getDetailDataMs09(payload) {
    let request = {
      url: this.getAPIUrl() + '/GetDetailDataMs09',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  
  /*
   * Lấy link file đính kèm có chữ ký
   */
  async getAttachmentEsign(payload) {
    let request = {
      url: this.getAPIUrl() + '/AttachmentEsign',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }
}

export default new DVCFileAPI();
